module.exports = __webpack_public_path__ + "img/consequences.764f050.jpg";